
import { TranslationRecord } from '../../types';

export const cookieConsent: TranslationRecord = {
  // Cookie Consent
  cookieConsentTitle: 'Cookie Consent',
  cookieConsentDescription: 'We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept All", you consent to our use of cookies as described in our Cookie Policy.',
  acceptAll: 'Accept All',
  rejectAll: 'Reject All',
  managePreferences: 'Manage',
  savePreferences: 'Save',
  cancel: 'Cancel',
  
  // Cookie Preferences
  cookiePreferencesTitle: 'Cookie Preferences',
  cookiePreferencesDescription: 'Manage how we use cookies on this site. Essential cookies cannot be disabled.',
  
  // Cookie Types
  necessaryCookies: 'Necessary Cookies',
  necessaryCookiesDescription: 'Essential for website functionality.',
  
  functionalCookies: 'Functional Cookies',
  functionalCookiesDescription: 'Enable enhanced functionality and personalization.',
  
  analyticsCookies: 'Analytics Cookies',
  analyticsCookiesDescription: 'Help us understand how visitors interact with our site.',
  
  marketingCookies: 'Marketing Cookies',
  marketingCookiesDescription: 'Used to display relevant advertisements across websites.',
  
  // Cookie Policy
  cookiePolicyIntro: 'Introduction',
  cookiePolicyEffectiveDate: 'Effective Date',
  cookiePolicyDescription: 'This Cookie Policy explains how we use cookies and similar technologies, why we use them, and your rights to control our use of them.',
  
  whatAreCookies: 'What Are Cookies?',
  cookieDefinition: 'Cookies are small data files placed on your device when you visit a website, helping it function efficiently and provide reporting information.',
  cookiePurpose: 'First-party cookies are set by us, while third-party cookies enable third-party features or functionality on our website.',
  
  cookieTypes: 'Types of Cookies We Use',
  analyticsSpecificCookies: 'Analytics cookies we use include',
  
  managingCookies: 'Managing Cookie Preferences',
  managingCookiesDescription: 'You can change your cookie preferences at any time by clicking the button below or through your browser settings.',
  manageCookiePreferences: 'Manage Cookie Preferences',
  browserSettings: 'Most browsers allow you to control cookies through their settings:',
  
  contactUs: 'Contact Us',
  cookiePolicyContact: 'If you have questions about our use of cookies, please contact us',
  lastUpdated: 'Last Updated',
  cookiePolicy: 'Cookie Policy',
  privacyPolicy: 'Privacy Policy',
};
